import api from 'api'

export interface W2WorkStatusSummaryItem {
  workWeek: string | null
  status: string
  workCount: number
}

export async function getW2WorkStatusSummary(): Promise<
  W2WorkStatusSummaryItem[]
> {
  const resp = await api.get('/admin/w2/work_status_summary')
  return resp.data as W2WorkStatusSummaryItem[]
}
